// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"188":"cdce664d678dd431c91e","600":"a0d01a89c3b106659d0f"}[chunkId] + ".css";
};